import React, { FC } from 'react'
import { FormProvider } from 'react-hook-form'
import { Button } from '@wmgtech/legato'
import { FormAdminContainer } from 'components'
import { UserForm } from 'modules/Users/components'
import { useCreateUser } from 'modules/Users/serviceHooks'

const CreateUser: FC = () => {
  const {
    control,
    userRolesOptions,
    onCreate,
    isSubmitButtonDisabled,
    handleSubmit,
    isExternalEmail,
    methods,
  } = useCreateUser()

  return (
    <FormAdminContainer
      backLink="/admin/users"
      actions={(
        <Button
          htmlType="submit"
          label="Save"
          colorType="secondary-white"
          containerStyle="outline"
          disabled={isSubmitButtonDisabled}
          form="user-form"
        />
      )}>
      <FormProvider {...methods}>
        <UserForm
          onSubmit={onCreate}
          isSubmitButtonDisabled={isSubmitButtonDisabled}
          handleSubmit={handleSubmit}
          control={control}
          isExternalEmail={isExternalEmail}
          userRolesOptions={userRolesOptions.filter((option) => !option.disabled)}
          isCreate
        />
      </FormProvider>
    </FormAdminContainer>
  )
}

export default CreateUser
